"use client"

import {useBoundStore} from "@/hooks/queries/stores/use-bound-store";
import {useShallow} from "zustand/react/shallow";
import {Tooltip, TooltipContent, TooltipTrigger} from "@/components/ui/tooltip";
import {User} from "@/pb/api/devplan/types/company";

export type UserInfoVariant = 'short' | 'full'

export function UserInfo(
  {id, variant: varParam, className, noTooltip}:
  { id: string | undefined, variant?: UserInfoVariant, className?: string , noTooltip?: boolean}) {
  const variant = varParam ?? 'short'
  const user = useBoundStore(useShallow(s => id && s.users[id]))
  if (!user) {
    return <div className={className}>unknown user</div>
  }
  if (noTooltip) {
    return <UserNameView user={user} variant={variant} className={className}/>
  }
  const {name, email} = user
  return <Tooltip delayDuration={1000}>
    <TooltipTrigger><UserNameView user={user} variant={variant} className={className}/></TooltipTrigger>
    <TooltipContent>
      <div>
        <InfoPart name="Name" part={name}/>
        <InfoPart name="Email" part={email}/>
      </div>
    </TooltipContent>
  </Tooltip>
}

function UserNameView({user, variant, className}: {user: User, variant: UserInfoVariant, className?: string}) {
  return <div className={className}>{getUserTextView(user, variant)}</div>
}

function InfoPart({name, part}: { name: string, part: string | undefined }) {
  if (!part) {
    return null
  }
  return <div className="flex items-center gap-2 text-sm">
    <div className="font-semibold">{name}:</div>
    <div>{part}</div>
  </div>
}

export function getUserTextView(user: User, variant: UserInfoVariant): string {
  const {name, email} = user
  if (name.length > 0) {
    return name
  }
  if (email.length > 0) {
    if (variant === "full") {
      return email
    }
    const parts = email.split("@");
    if (parts.length === 1) {
      return email
    }
    return `${parts[0]}`
  }
  return ""
}